import {
  CloudFlareStatus,
  DomainMappingKind,
  PhpVersion,
  Tag,
  Website,
  WebsiteDomain,
  WebsiteKind,
  WebsiteStatus,
} from 'src/orchd-client';
import range from 'lodash/range';

const stub: {
  phpVersion: PhpVersion;
  tags: Tag[];
  subdomains: WebsiteDomain[];
  aliases: WebsiteDomain[];
} = {
  phpVersion: PhpVersion.php74,
  tags: [
    {
      id: 1,
      tag: `fan-site`,
      colorCode: 'orange',
    },
    {
      id: 2,
      tag: `enterprise`,
      colorCode: 'blue',
    },
    {
      id: 3,
      tag: `commerce`,
      colorCode: 'fuscia',
    },
    {
      id: 4,
      tag: `internal`,
      colorCode: 'green',
    },
  ],
  subdomains: [
    {
      id: 'dd7fc10e-80e0-401b-a394-e39945e429ba',
      domain: 'somesub.domain.com',
      documentRoot: '/public_html',
      kind: DomainMappingKind.primary,
      cloudflareStatus: CloudFlareStatus.Connected,
    },
    {
      id: '37b9d48a-7bdc-4b7f-9875-2cc4d62b4621',
      domain: 'anothersub.domain.com',
      documentRoot: '/public_html',
      kind: DomainMappingKind.primary,
      cloudflareStatus: CloudFlareStatus.Connected,
    },
    {
      id: 'be587040-4bbf-4885-b9ad-0429197cddcf',
      domain: 'yetanothersub.domain.com',
      documentRoot: '/public_html',
      kind: DomainMappingKind.primary,
      cloudflareStatus: CloudFlareStatus.Connected,
    },
  ],
  aliases: [
    {
      id: '935df3c8-891d-41a8-97b7-3ee744b5b126',
      domain: 'aliasdomain.com',
      documentRoot: '/public_html',
      kind: DomainMappingKind.alias,
      cloudflareStatus: CloudFlareStatus.Connected,
    },
    {
      id: 'b2d61baf-d6b5-43df-9d7f-314f980040a1',
      domain: 'aliasdomain2.com',
      documentRoot: '/public_html',
      kind: DomainMappingKind.alias,
      cloudflareStatus: CloudFlareStatus.Connected,
    },
  ],
};

interface AdditionalOptions {
  kind?: WebsiteKind;
  status?: WebsiteStatus;
  suspendedBy?: string;
}

export const getMockWebsites = (n: number, options?: AdditionalOptions): Website[] => {
  return range(1, n + 1).map((number): Website => {
    let kind = WebsiteKind.normal;
    let status = WebsiteStatus.active;
    let aliases: WebsiteDomain[] = [];
    let subdomains: WebsiteDomain[] = [];
    let tags: Tag[] = [];
    let suspendedBy: string | undefined;
    if (number % 5 === 0) {
      status = WebsiteStatus.deleted;
    } else if (number % 3 === 0) {
      status = WebsiteStatus.disabled;
      tags = stub.tags ? stub.tags.slice(1, 3) : tags;
      subdomains = stub.subdomains.slice(2);
      aliases = stub.aliases.slice();
    } else if (number % 2) {
      suspendedBy = '23eff2a1-aa9c-4849-af8f-aa35d0ab0852';
      tags = stub.tags ? stub.tags.slice(0, 1) : tags;
      subdomains = stub.subdomains.slice(0, 1);
      aliases = stub.aliases.slice(0, 1);
    }
    // override options
    if (options?.kind) kind = options.kind;
    if (options?.status) status = options.status;
    if (options && 'suspendedBy' in options) suspendedBy = options.suspendedBy;

    return {
      id: String(number),
      orgId: 'some-org-id',
      subscriptionId: number,
      tags,
      size: 345000000,
      plan: 'some plan',
      planId: number,
      colorCode: String(number),
      status,
      phpVersion: stub.phpVersion,
      domain: {
        domain: `site-${number}.info-marketing-universe.io`,
        id: `some-domain-id-${number}`,
        documentRoot: '/public_html',
        kind: DomainMappingKind.primary,
        cloudflareStatus: CloudFlareStatus.Connected,
      },
      subdomains,
      aliases,
      kind,
      suspendedBy,
      createdAt: '2020-07-29T08:44:20.099067012Z',
    };
  });
};

export const websitesMock10 = getMockWebsites(10);
export const websitesMock = getMockWebsites(33);

export const websiteWithFilerdAddress: Website = {
  ...websitesMock10[1],
  filerdAddress: 'https://ktjjmglj.local-enhance.com:43209',
};

export const [website] = getMockWebsites(1);
